import React from "react";
import { Link } from "react-router-dom";

import { useParams } from "react-router";
import { formatPhone, formatDate } from "utils/common";
import { storeValue, accountValue, address, contactPhone, accountSummary, nationalParent } from "../utils";
import { api } from "store/slices/api";
import "./style.scss";

const QuoteSummaryFields = () => {
  const { quoteId } = useParams();
  const { data: quote = {} } = api.useGetPriceQuoteQuery(quoteId);

  return (
    <div className="">
      <div className="d-md-flex flex-column flex-md-row mt-5 mt-md-0 overflow-auto position-relative">
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Quote Name</div>
          <div className="info-item__value text-end text-md-start">{quote.quoteName}</div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Expiration Date</div>
          <div className="info-item__value text-end text-md-start">
            {["Upon 30 days notice", undefined].includes(quote.expirationDate)
              ? quote.expirationDate
              : formatDate(quote.expirationDate)}
          </div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Store</div>
          <div className="info-item__value text-end text-md-start">
            {storeValue(quote.storeNumber, quote.storeName, formatPhone(quote.storePhoneNumber))}
          </div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Account</div>
          <div className="info-item__value text-end text-md-start">
            {accountSummary(
              accountValue(quote.accountNumber, quote.accountName),
              address(quote.street, quote.city, quote.state, quote.zip),
              contactPhone(quote.contactName, formatPhone(quote.phone)),
            )}
          </div>
        </div>
      </div>

      <div className="d-md-flex flex-column flex-md-row mt-md-5 mb-5 overflow-auto position-relative spacing">
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Customer Name</div>
          <div className="info-item__value text-end text-md-start">
            {!quote.customerName ? "N/A" : quote.customerName}
          </div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Sales Representative</div>
          <div className="info-item__value text-end text-md-start">{!quote.salesRep ? "N/A" : quote.salesRep}</div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">National Parent</div>
          <div className="info-item__value text-end text-md-start">
            {nationalParent(quote.parentNumber, quote.parentName, quote.execNumber, quote.execName)}
          </div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Created from Site</div>
          <div className="info-item__value text-end text-md-start">
            {!quote.quoteType ? "N/A" : <Link to={`/siteRepo/site/${quote.quoteType}`}>{quote.quoteType}</Link>}
          </div>
        </div>
      </div>

      <div className="summary_footer"></div>
    </div>
  );
};

export default QuoteSummaryFields;
